import React, { Component } from 'react'
import { fetchMenu } from '../api/menu.js'

class MenuHighlights extends Component {
    constructor(props) {
        super(props);
        this.state = {
            items: []
        };
        this.cardsRef = [];
    }

    componentDidMount() {
        fetchMenu().then(data => {
            // Find the signature category (絕配精選 or first category)
            var signatureKey = null;
            for (var i = 0; i < data.cat_list.length; i++) {
                if (data.cat_list[i].indexOf('精選') !== -1 || data.cat_list[i].indexOf('絕配') !== -1) {
                    signatureKey = data.cat_list[i];
                    break;
                }
            }
            if (!signatureKey && data.cat_list.length > 0) {
                signatureKey = data.cat_list[0];
            }

            if (signatureKey && data.menu_dict[signatureKey]) {
                this.setState({
                    items: data.menu_dict[signatureKey].slice(0, 4)
                }, this.observeCards);
            }
        }).catch(function() {
            // Silently fail — section just won't show
        });
    }

    observeCards() {
        var self = this;
        if ('IntersectionObserver' in window) {
            this.observer = new IntersectionObserver(
                function(entries) {
                    entries.forEach(function(entry) {
                        if (entry.isIntersecting) {
                            entry.target.classList.add('visible');
                            self.observer.unobserve(entry.target);
                        }
                    });
                },
                { threshold: 0.05, rootMargin: '50px 0px 50px 0px' }
            );
            this.cardsRef.forEach(function(el) {
                if (el) self.observer.observe(el);
            });
        } else {
            this.cardsRef.forEach(function(el) {
                if (el) el.classList.add('visible');
            });
        }
    }

    componentWillUnmount() {
        if (this.observer) this.observer.disconnect();
    }

    render() {
        if (this.state.items.length === 0) return null;
        var self = this;

        return (
            <section className="menu_highlights">
                <div className="section_header">
                    <span className="section_label">Signature Picks</span>
                    <h2 className="section_title">招牌精選</h2>
                </div>
                <div className="highlights_grid">
                    {this.state.items.map(function(item, index) {
                        return (
                            <div key={index} className="highlight_card reveal" ref={function(el) { self.cardsRef[index] = el; }} style={{ transitionDelay: (index * 0.1) + 's' }}>
                                {item.more_info.img && (
                                    <img
                                        src={item.more_info.img}
                                        className="highlight_card_img"
                                        alt={item.name}
                                    />
                                )}
                                <div className="highlight_card_body">
                                    <h3 className="highlight_card_name">{item.name}</h3>
                                    {item.more_info.desc && (
                                        <p className="highlight_card_desc">{item.more_info.desc}</p>
                                    )}
                                    {item.more_info.price && (
                                        <span className="highlight_card_price">{item.more_info.price}</span>
                                    )}
                                </div>
                            </div>
                        );
                    })}
                </div>
                <div className="highlights_cta_wrap">
                    <a href="/menu" className="brand_teaser_link" style={{ display: 'inline-flex' }}>
                        查看完整菜單 →
                    </a>
                </div>
            </section>
        );
    }
}

export default MenuHighlights;
